import {SIDEBAR_OPEN, SIDEBAR_CLOSE} from 'app/redux/constants/actionTypes';

export default function sidebarToggle(state = false, action) {
  switch (action.type) {
    case SIDEBAR_OPEN:
      return 'open';
    case SIDEBAR_CLOSE:
      return 'close';
    default:
      return 'close';
  }
}